<template>
  <div>
    <b-field custom-class="mb-4px"
      :class="isPanier ? ' mb-20' : 'mb-10'"
      v-if="isReadonly">
      <template slot="label">
        <p
          :class="isPanier ? 'has-text-default is-size-7 '
            : 'is-size-6 has-text-grid-1 has-text-weight-bold'">
          {{$t('general.societe.title')}}
        </p>
      </template>
      <b-input :class="{'inputSociete' : isPanier}"
        disabled
        v-model="societeActive.libelle">
      </b-input>
    </b-field>
    <b-field v-else>
      <b-select
        v-model="societeSelected"
        :placeholder="$t('general.societe.placeholder')"
        expanded>
        <option
          v-for="societe in societes"
          :key="societe.id"
          :value="societe.id">
          {{ societe.libelle }}
        </option>
      </b-select>
    </b-field>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const Societe = createNamespacedHelpers('societe');
export default {
  props: {
    isReadonly: {
      type: Boolean,
      default: true,
      required: false,
    },
    isPanier: {
      type: Boolean,
      default: false,
      required: false,
    }
  },
  computed: {
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
      societeActive: 'societeActive',
      societes: 'societes',
    }),
    societeSelected: {
      get() { return this.societeActiveId; },
      set(value) { this.setSocieteId(value); },
    }
  },
  methods: {
    ...Societe.mapActions({
      setSocieteId: 'setSocieteId',
    }),
  },
};
</script>

<style>

</style>
